import AnnouncementDetailPage from './AnnouncementDetailPage';

// Ce composant réexporte simplement AnnouncementDetailPage
// Le composant original fonctionne déjà pour les visiteurs publics car :
// - Les statistiques sont conditionnées à isAgent (qui sera false pour les utilisateurs non authentifiés)
// - Les boutons admin ne sont pas affichés car basés sur les rôles utilisateur
// - L'API announcementAPI.getBySlug ne nécessite pas d'authentification

export default AnnouncementDetailPage;
